import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { RESTAURANT, WHATSAPP_URL } from "@/lib/assets";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="mt-24 bg-[#8B1A2B] text-[#FDFBF7] pt-20 pb-10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid md:grid-cols-4 gap-14">
        <div className="md:col-span-2">
          <div className="font-serif-display italic text-[#FDFBF7] text-4xl leading-none">
            La Matze
          </div>
          <div className="mt-3 text-[10px] tracking-[0.32em] uppercase text-[#F3D1D6]">
            Restaurant · Genève
          </div>
          <p className="mt-6 max-w-md text-[15px] leading-relaxed text-[#FDFBF7]/80">
            Cuisine suisse-italienne, rue Chaponnière depuis toujours.
            Charbonnade, fondues, filet de perche, entrecôte Matze.
          </p>
        </div>

        <div>
          <div
            className="lm-eyebrow"
            style={{ color: "#F3D1D6" }}
          >
            Adresse
          </div>
          <ul className="mt-5 space-y-3 text-[14px] text-[#FDFBF7]/90">
            <li className="flex items-start gap-3">
              <MapPin size={16} className="mt-0.5 text-[#F3D1D6]" />
              {RESTAURANT.address}
            </li>
            <li className="flex items-center gap-3">
              <Phone size={16} className="text-[#F3D1D6]" />
              <a
                href={`tel:${RESTAURANT.phone_tel}`}
                data-testid="footer-phone"
                className="hover:text-white"
              >
                {RESTAURANT.phone}
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Mail size={16} className="text-[#F3D1D6]" />
              <a
                href={`mailto:${RESTAURANT.email}`}
                data-testid="footer-email"
                className="hover:text-white"
              >
                {RESTAURANT.email}
              </a>
            </li>
          </ul>
        </div>

        <div>
          <div
            className="lm-eyebrow"
            style={{ color: "#F3D1D6" }}
          >
            Horaires
          </div>
          <p className="mt-5 flex items-start gap-3 text-[14px] text-[#FDFBF7]/90">
            <Clock size={16} className="mt-0.5 text-[#F3D1D6]" />
            <span>
              Lundi – Samedi<br />
              10h00 – 22h00<br />
              <span className="text-[#FDFBF7]/60">Fermé le dimanche</span>
            </span>
          </p>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noreferrer noopener"
            data-testid="footer-cta-reserver"
            className="inline-flex items-center justify-center mt-8 h-11 px-7 bg-[#FDFBF7] text-[#8B1A2B] uppercase tracking-[0.14em] text-[11px] font-semibold hover:bg-[#F3D1D6] hover:text-[#6B141E] transition-colors"
          >
            Réserver via WhatsApp
          </a>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-10 mt-16 pt-8 border-t border-[#FDFBF7]/15 flex flex-col sm:flex-row justify-between gap-3 text-[12px] text-[#FDFBF7]/60">
        <span>© {new Date().getFullYear()} La Matze — Genève.</span>
        <span className="tracking-widest uppercase">Rue Chaponnière · Pâquis</span>
      </div>
    </footer>
  );
}
